import { MenuItem } from './menu.types'
 
export const menuAdmin = (navigate: Function): MenuItem[] => {
 
	return [
		{
			label: 'Medicos',
			action: () => navigate('/med/admin/medicos')
		},
		{
			label: 'Pacientes',
			action: () => navigate('/med/pacientes')
		},
		{
			label: 'Turnos',
			action: () => navigate('/med/turnos')
		},
		{
		  label: 'Tablas',
		  subItems: [
			{
				label: 'Especialidades',
				action: () => navigate('/med/especialidades'),
			},
			{
				label: 'Triage',
				action: () => navigate('/med/triage'),
			},
			{
				label: 'Parámetros',
				action: () => navigate('/med/params'),
			},
		  ]
		},
		{
			label: 'Perfil',
			subItems: [
				{
					label: 'Cambiar Contraseña',
					action: () => navigate('/med/change-pass')
				},
				{
					label: 'Salir',
					action: () => navigate('/med/login')
				}
			]
		}
	]
}
